import api from '../../api'
import { toHiragana, toKatakana } from './utils'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getAllItems: (state) => {
    return flatten(state.all)
  },
  getAllForList: (state) => state.all.filter((g) => g.menu),
  getAllForPlanTop: (state) => {
    return flatten(state.all).filter(genre => genre.planTop)
  },
  getParentGenreIds: (state) => state.all.map((genre) => genre.id ),
  getAllWithoutEmpty: (state, _getters, _rootState, rootGetters) => {
    return state.all.filter((genre) => {
      if (genre.planMenu && genre.type !== "favorite") {
        return rootGetters['places/getPlacesByGenre'](genre).length > 0
      }
    })
  },
  search: (state) => (word) => {
    return state.all
      .filter(genre => genre.menu)
      .flatMap(genre => genre.items)
      .filter(genre => isMatch(genre, word))
  },
  getFavoriteGenre: (state) => {
    return state.all.find(genre => genre.type === "favorite")
  },
  getMapIcon: (state) => (place) => {
    if (place.genreIds !== undefined && place.genreIds.length > 0) {
      return flatten(state.all).find(genre => genre.id === place.genreIds[0])
    }
  },
  getGenreFromId: (state) => (id) => {
    return flatten(state.all).find(genre => genre.id === id || genre.tagId === id)
  }
}

const actions = {
  fetchAll ({ rootGetters, commit, dispatch }) {
    return new Promise((resolve) => {
      api.getGenres(rootGetters['user/getLang'], rootGetters['user/getAreaId'])
        .then((genres) => {
          dispatch('user/updateFilter', genres, { root: true })
          commit('setGenres', genres)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setGenres (state, genres) {
    state.all = genres
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

/**
 * Private function
 */

function isMatch(genre, word) {
  const hiragana = toHiragana(word)
  const katakana = toKatakana(word)

  // NOTE: 呼び出し元でitemsがないジャンルの場合flatMapするとundefinedがはいってしまうため
  if (!genre) return false

  return genre.name.indexOf(hiragana) > -1 ||
    genre.name.indexOf(katakana) > -1
}

function flatten(genres) {
  let a = []
  genres.forEach(genre => {
    a.push(genre)
    if (genre.items) a.push(genre.items)
  })
  return a.flat()
}
